<div class="main-wrapper clearfix">

  <!-- Added only: doctors-header -->
  <div class="row doctors-header">
    <div class="col-sm-3 col-xs-12">
      <h3 class="mt0">Doctors</h3>
    </div>

    <div class="col-lg-6 col-xs-8">
      <div class="input-group">
        <input
          class="form-control"
          placeholder="Associate doctor from library"
          [(ngModel)]="token"
          [typeahead]="data_source"
          typeaheadWaitMs="500"
          [typeaheadAsync]="true"
          [typeaheadOptionsLimit]="7"
          [typeaheadOptionField]="'doctor_full_name'"
          (typeaheadLoading)="changeTypeaheadLoading($event)"
          (typeaheadNoResults)="changeTypeaheadNoResults($event)"
          (typeaheadOnSelect)="typeaheadOnSelect($event)"
        />

        <div
          class="input-group-addon"
          *ngIf="typeaheadLoading">

          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>

      <div
        *ngIf="typeaheadNoResults"
        class="text-danger fs13">

        No Results Found!
      </div>
    </div>

    <div class="col-lg-3 col-xs-4 text-right">
      <a
        class="btn btn-inverse"
        (click)="doctor_form()">

        Add Doctor
      </a>
    </div>
  </div>

  <hr class="hr-line mt-lg">

  <ng-container *ngIf="show_doctor_form">
    <h3 class="mt0 mb-xl text-primary">
      Add New Doctor
    </h3>

    <app-doctor-form
      [doctor]="new_doctor"
      (edited_doctor)="doctor_saved($event)"
      (form_hidden)="handle_new_doctor_hidden()">
    </app-doctor-form>
  </ng-container>

  <div
    class="media white-container-box p-lg mb-lg"
    *ngIf="associate_doctor_profile">

    <h4 class="mt0">Associate Doctor</h4>

    <hr class="hr-line mt0">

    <div class="media-left">
      <img
        class="img-circle thumb150"
        [src]="associate_doctor_profile.profile_pic.modal.img"
        alt="Image"
      />
    </div>

    <div class="media-body pl-lg">
      <h3 class="mt0">
        {{ associate_doctor_profile.complete_name }}
      </h3>

      <h4>
        {{ associate_doctor_profile.designation }}
      </h4>

      <!-- Added only: doctor-contact-list -->
      <div class="mt-lg doctor-contact-list">
        <span
          class="mr"
          *ngIf="
            associate_doctor_profile.client.contact_numbers[1] &&
            associate_doctor_profile.client.contact_numbers[1].value
          ">

          <em class="fa fa-fax"></em>

          {{ associate_doctor_profile.client.contact_numbers[1].value }}
        </span>

        <span
          class="mr"
          *ngIf="
            associate_doctor_profile.client.contact_numbers[0] &&
            associate_doctor_profile.client.contact_numbers[0].value
          ">

          <em class="icon-phone"></em>

          {{
            associate_doctor_profile.client.contact_numbers[0].value
              | mask: '(000) 000-0000'
          }}
        </span>

        <span>
          <em class="fa icon-envelope fa-fw"></em>

          {{ associate_doctor_profile.client.email }}
        </span>
      </div>

      <!-- Added only: doctor-actions -->
      <div class="clearfix mt-lg doctor-actions">
        <a
          class="btn btn-primary mr"
          (click)="associate_doctor_with_practice()">

          Accept
        </a>

        <a
          class="btn btn-inverse"
          (click)="renew_associate_doctor()">

          Cancel
        </a>
      </div>
    </div>
  </div>

  <ng-container *ngIf="show_doctors_listing">
    <ng-container *ngFor="let doctor_group of group_array_for_pair">
      <ng-container *ngFor="let doctor of doctor_group; let i = index">
        <app-doctor-profile-detail
          class="practice-list-doctor"
          [doctor]="doctor"
          [doctor_permissions]="doctor_permissions"
          [practice]="practice"
          [index]="i"
          (expanded)="doctor_expanded($event)">
        </app-doctor-profile-detail>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
